import moment from "moment";
import {CalendarEvent} from "@models/calendar";
import {appApi} from "@services/api.service";

const endpointPrefix = 'worker/calendar-events';

const getCalendarEventsByDates = async (startDate: Date, endDate: Date): Promise<CalendarEvent[]> => {
	const start: string = moment(startDate, 'YYYY-MM-DD').format('DD-MM-YYYY');
	const end: string = moment(endDate, 'YYYY-MM-DD').format('DD-MM-YYYY');

	const response = await appApi.get(endpointPrefix + '?startDate=' + start + '&endDate=' + end);

	return response.data;
}

export {
	getCalendarEventsByDates,
};
